import type { SharePermission } from '@/types';
import { SHARE_PERMISSION_LABELS } from '@/types';

export function sharePermissionLabel(permission: SharePermission | string): string {
  return SHARE_PERMISSION_LABELS[permission as SharePermission] || permission;
}

export function canSetRemarkDeadline(permission: SharePermission | string): boolean {
  return permission === 'participant';
}

/** Share remark deadline (due_at) has passed — applies to all cohort viewers on that share. */
export function isShareDueAtPassed(dueAt?: string | null): boolean {
  if (!dueAt) return false;
  const dueMs = new Date(dueAt).getTime();
  return !Number.isNaN(dueMs) && dueMs < Date.now();
}
